import Http from '@/utils/http'
import NLoginApi = global.NLoginApi
import { RequestType } from '@/typings/enum/Common'
// import { objectToFormData } from '@/utils/lib'

class Login extends Http {
  // 登录
  public async login(data: NLoginApi.LoginRequestData) {
    return await super.request<NLoginApi.LoginResponse>({
      url: '/login',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data
    })
  }

  public async outLogin(data: NLoginApi.OutLoginRequestData) {
    return await super.request<NLoginApi.OutLoginResponse>({
      url: '/login/outLogin',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data
    })
  }

  public async getSMS(params: NLoginApi.CodeSmsRequestData) {
    return await super.request<NLoginApi.CodeSmsResponse>({
      url: '/code/sms',
      method: RequestType.Get,
      headers: {
        'Content-Type': 'application/json'
      },
      params
    })
  }

  public async loginMobile(data: NLoginApi.SMSLoginRequestData) {
    return await super.request<NLoginApi.SMSLoginResponse>({
      url: '/login/mobile',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data
    })
  }

  public async changeCurrentRole(params: NLoginApi.ChangeCurrentRoleRequestData) {
    return await super.request<NLoginApi.ChangeCurrentRoleResponse>({
      url: '/crossbowSystem/changeCurrentRole',
      method: RequestType.Get,
      headers: {
        'Content-Type': 'application/json'
      },
      params
    })
  }
}

export default Login
